export default __webpack_public_path__ + "static/media/cooplogobg.d67c53e4.png";